import { AxiosError } from 'axios';

import { getURIParams, Log } from '@x_x_x/utils';

import { ApiError, IApiErrorParams } from '@utils';

import { IApiBaseRequestParams, IApiBaseResponseData, IApiRequest, IApiResponse } from '@interfaces';

import { IApi } from '../../types';

export class BaseApi {

	protected api: IApi;

	constructor(api: IApi) {
		this.api = api;
	}

	async http<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>): Promise<IApiResponse<P>> {
		const transport = this.api.getTransport();
		const data = params.data && !params.isNoProcessData ? getURIParams(params.data as unknown as Record<string, string>) : params.data || null;

		try {
			return await transport.http({
				...params,
				data,
			});
		} catch (errObj) {
			const err = errObj as AxiosError;

			const error = new ApiError({
				...err,
				status: err.response?.status,
				statusText: err.response?.statusText,
				serverError: err.response?.data as IApiErrorParams['serverError'],
				request: {
					url: params.url,
					method: params.method,
					data: data as string,
				},
			});

			Log.errorRequest(error);

			throw error;
		}
	}

	async get<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>): Promise<IApiResponse<P>> {
		params.method = 'GET';

		return this.http(params);
	}

	async post<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>): Promise<IApiResponse<P>> {
		params.method = 'POST';

		return this.http(params);
	}

	async put<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>): Promise<IApiResponse<P>> {
		params.method = 'PUT';

		return this.http(params);
	}

	async delete<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>): Promise<IApiResponse<P>> {
		params.method = 'DELETE';
		params.headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
		};

		return this.http(params);
	}

}
